module.exports = __webpack_public_path__ + "img/sign-73.27ac3b19.jpg";